module.exports = __webpack_public_path__ + "public/img/aboultus.d3d6569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/aboultus.png
// module id = u+//
// module chunks = 1